module.exports = __webpack_public_path__ + "static/media/ic_info.23870d83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_info.svg
// module id = 292
// module chunks = 0